<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-text-field
          v-model="name"
          label="Name"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="description"
          label="Description"
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-checkbox v-model="notInUse" label="Not in Use" hide-details />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "template-type-edit-dialog",

  props: {
    show: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "New Template",
      description: this.value ? this.value.description : "",
      notInUse: this.value ? this.value.notInUse : false,
    };
  },

  watch: {
    value(newValue) {
      this.name = newValue ? newValue.name : "New Template";
      this.description = newValue ? newValue.description : "";
      this.notInUse = newValue ? newValue.notInUse : false;
    },
  },

  computed: {
    editorTitle() {
      return this.value ? "Edit Template Type" : "Create Template Type";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "";
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value ? this.value.id : undefined,
        name: this.name,
        description: this.description,
        notInUse: this.notInUse,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/templates/template-types/TemplateTypeEditDialog.vue